const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
if(urlParams.get('product_handle')) {
    const current_product = urlParams.get('product_handle');
    var scroll_to_product = document.querySelectorAll('[data-product-handle="' + current_product + '"]')[0]
    var scrol_to_element = scroll_to_product.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({top: scrol_to_element - 200, behavior: 'smooth'});
    // const url = window.location;
    // let params = new URLSearchParams(url.search);
    // params.delete('product')
    // window.history.replaceState(null, null, location.pathname);
}
var requested_next_page = false;
var requested_previous_page = false;
const handleInfiniteScroll = () => {
    var body_wo_footer = document.getElementById("body_wo_footer");
    // var toolbar_section = document.getElementById("shopify-section-toolbar");
    // var header_section = document.getElementById("shopify-section-header");
    // var collection_header = document.getElementById("CollectionHeaderSection");

    const endOfPage = window.innerHeight + window.pageYOffset >= body_wo_footer.offsetHeight - 2000;
    // const begOfPage = window.pageYOffset <= toolbar_section.offsetHeight + header_section.offsetHeight + collection_header.offsetHeight + 200;

    if(endOfPage && !requested_next_page && next_url) {
        loadMoreProducts();
    }
    // if(begOfPage && !requested_previous_page && previous_url) {
    //     loadPreviousProducts();
    // }
}
window.addEventListener("scroll", handleInfiniteScroll);
var products_on_page = document.getElementsByClassName("collection-grid")[0];
var next_url = products_on_page.dataset.nextUrl;
var previous_url = products_on_page.dataset.previousUrl;
var load_more_spinner = document.getElementsByClassName("load-more__spinner")[0];
var load_previous_spinner = document.getElementsByClassName("load-previous__spinner")[0];
var load_more_btn = document.getElementsByClassName("load-more__button")[0];
var load_previous_btn = document.getElementsByClassName("load-previous__button")[0];
function loadMoreProducts() {
    var products_on_page = document.getElementsByClassName("collection-grid")[0];
    var load_more_spinner = document.getElementsByClassName("load-more__spinner")[0];
    var load_more_btn = document.getElementsByClassName("load-more__button")[0];
    var product_elements = document.getElementsByClassName("collection-grid");
    var last_product_element = document.getElementsByClassName("collection-grid")[product_elements.length -1];
    var collection_grid = document.getElementById('infinite_collection');
    var next_url = last_product_element.dataset.nextUrl;
    requested_next_page = true;
    if(next_url) {
        load_more_btn.style.display='none';
        load_more_spinner.style.display='block';
        fetch(next_url, {
            method: 'GET',
            credentials: 'same-origin'
        }).then(function (response) {
            return response.text();
        }).then(function(html) {
            var parser = new DOMParser();
            var next_page = parser.parseFromString(html, 'text/html');
            var new_products = next_page.getElementsByClassName("collection-grid")[0];
            collection_grid.append(new_products);
            var new_url = new_products.dataset.nextUrl;
            theme.sections.register('collection-template', theme.Collection);
            load_more_spinner.style.display ='none';
            next_url = new_url;
            if(!next_url) {
                load_more_btn.style.display='none';
            } else {
                load_more_btn.style.display='block';
            }
            requested_next_page = false;
            // window.history.replaceState( null, null, next_url );

        })
    }
}
function loadPreviousProducts() {
    var products_on_page = document.getElementsByClassName("collection-grid")[0];
    var previous_url = products_on_page.dataset.previousUrl;
    var load_previous_spinner = document.getElementsByClassName("load-previous__spinner")[0];
    var load_previous_btn = document.getElementsByClassName("load-previous__button")[0];
    var collection_grid = document.getElementById('infinite_collection');
    requested_previous_page = true;
    load_previous_btn.style.display='none';
    load_previous_spinner.style.display='block';
    fetch(previous_url, {
        method: 'GET',
        credentials: 'same-origin'
    }).then(function (response) {
        return response.text();
    }).then(function(html) {
        var parser = new DOMParser();
        var previous_page = parser.parseFromString(html, 'text/html');
        var previous_products = previous_page.getElementsByClassName("collection-grid")[0];
        var current_scroll = document.documentElement.scrollTop;
        collection_grid.prepend(previous_products);
        window.scrollTo({top: current_scroll + previous_products.offsetHeight, behavior: 'smooth'});
        theme.sections.register('collection-template', theme.Collection);
        load_previous_spinner.style.display ='none';
        var new_url = previous_products.dataset.previousUrl;
        previous_url = new_url;
        if(!previous_url) {
            load_previous_btn.style.display='none';
        } else {
            load_previous_btn.style.display='block';
        }
        requested_previous_page = false;
        // window.history.replaceState( null, null, previous_url );

    })
}
function replaceCollectionURL(page, product_handle) {
    let params = new URLSearchParams(location.search);
    params.delete('product_handle');
    params.delete('page');
    window.history.replaceState( null, null,'?' + params + '&page=' + page + '&product_handle=' + product_handle );

}

// var scroll_to_product = document.querySelectorAll('[data-product-handle="connect-logistics-pablo-claro-chardonnay-798548"]')[0]
// var scrol_to_element = scroll_to_product.getBoundingClientRect().top + window.pageYOffset;

// window.scrollTo({top: scrol_to_element - 200, behavior: 'smooth'});
// async function loadPreviousProductsPage() {
//     requested_previous_page = true;
//     load_previous_btn.style.display='none';
//     load_previous_spinner.style.display='block';
//     await fetch(previous_url, {
//         method: 'GET',*
//         credentials: 'same-origin'
//     }).then(function (response) {
//         return response.text();
//     }).then(function(html) {
//         var parser = new DOMParser();
//         var previous_page = parser.parseFromString(html, 'text/html');
//         var previous_products = previous_page.getElementsByClassName("collection-grid")[0];
//         products_on_page.prepend(previous_products);
//         theme.sections.register('collection-template', theme.Collection);
//         load_previous_spinner.style.display ='none';
//         load_previous_btn.style.display='block';
//         var new_url = previous_products.dataset.previousUrl;
//         previous_url = new_url;
//         requested_previous_page = false;
//     })
//     return previous_url;
// }

// async function getPreviousProducts() {
//     var i = 0;
// while(previous_url) {
//     var page = await loadPreviousProductsPage();
//     i++;
// }
// }


